import { Reducer } from 'redux';

import { InitiateOrderPaymentActionTypes, InitiateOrderPaymentActions } from '../actions/InitiateOrderPayment';
import { IErrorActionData } from '../../../models/Error';
import { IInitiateOrderPaymentSuccessActionData } from '../models/InitiateOrderPayment';

export interface IInitiateOrderPaymentState {
  initiateOrderPaymentStatus: IInitiateOrderPaymentSuccessActionData;
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initiateOrderPaymentDetailsState = {
  initiateOrderPaymentStatus: {},
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IInitiateOrderPaymentState;

const InitiateOrderPaymentReducer: Reducer<IInitiateOrderPaymentState, InitiateOrderPaymentActions> = (
  state = initiateOrderPaymentDetailsState,
  action: InitiateOrderPaymentActions,
): IInitiateOrderPaymentState => {
  switch (action.type) {
    case InitiateOrderPaymentActionTypes.INITIATE_ORDER_PAYMENT:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case InitiateOrderPaymentActionTypes.INITIATE_ORDER_PAYMENT_SUCCESS: {
      return {
        ...state,
        initiateOrderPaymentStatus: {
          data: action.payload.data,
          success: action.payload.success,
        },
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case InitiateOrderPaymentActionTypes.INITIATE_ORDER_PAYMENT_FAILURE:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case InitiateOrderPaymentActionTypes.INITIATE_ORDER_PAYMENT_RESET:
      return initiateOrderPaymentDetailsState;

    default:
      return state;
  }
};

export default InitiateOrderPaymentReducer;
